import React from 'react';
import {apiRemoveTeamMember} from 'constants/Api';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {reduxToggleSidePanel} from 'appredux/actions';
import {ISupplierUserProfile} from 'constants/interfaces';
import {connect} from 'react-redux';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import {Route} from 'react-router-dom';
import {NavigationService} from 'services/index';

type RemoveMemberProp = {
  user: ISupplierUserProfile;
  teamMember: ISupplierUserProfile;
};

/**
 * Component for removing team members
 */
class RemoveTeamMember extends React.Component<RemoveMemberProp> {
  state = {
    shouldShowSuccess: false,
    isLoading: false,
  };

  cancel() {
    reduxToggleSidePanel(false, undefined);
  }

  submit() {
    const {teamMember} = this.props;
    this.setState({isLoading: true}, () => {
      this.setState({shouldShowSuccess: true, isLoading: false});

      apiRemoveTeamMember(teamMember.id)
        .then((data: any) => {
          if (data.success) {
            this.setState({shouldShowSuccess: true, isLoading: false});
          } else {
            alert(data.message);
          }
        })
        .catch((e: any) => {
          alert(e.message);
          this.setState({isLoading: false});
        });
    });
  }

  render() {
    const {teamMember} = this.props;
    const {shouldShowSuccess, isLoading} = this.state;
    const teamLink = this.props.user.isAdmin ? '/company/team' : '/team';

    if (shouldShowSuccess) {
      return (
        <Route
          render={({history}) => (
            <div className="side-panel-success-container">
              <div className="mid-section">
                <div className="success-gif">
                  <CheckIcon />
                </div>
                <div className="success-msg">
                  Team member removed successfully
                </div>
              </div>
              <div className="btn-container">
                <Button
                  className="primary-btn"
                  type="submit"
                  variant="outlined"
                  color="primary"
                  disabled={isLoading}
                  onClick={() => {
                    reduxToggleSidePanel(false, null);
                    NavigationService.navigate('/');
                    setTimeout(() => NavigationService.navigate(teamLink), 50);
                  }}
                >
                  View Team
                </Button>
              </div>
            </div>
          )}
        />
      );
    }

    return (
      <div className="generic-form-container">
        <div className="form-container">
          <div className="form">
            <Typography variant="subtitle1" className="sub-header">
              Are you sure you want to remove the following team member?
            </Typography>
            <Box
              className="product-picture-container"
              display="flex"
              flexDirection="column"
              alignItems="center"
              p={4}
            >
              <Avatar src={teamMember.pictureUrl} className={'avatar'} />
              <Typography variant="subtitle1">
                {teamMember.name} {teamMember.surname}
              </Typography>
            </Box>
            <div className="btns row">
              <Button
                className={'secondary-btn'}
                variant="outlined"
                onClick={() => this.cancel()}
              >
                Cancel
              </Button>
              <Button
                className={'primary-btn'}
                variant="outlined"
                color="primary"
                onClick={() => this.submit()}
              >
                {isLoading ? (
                  <CircularProgress color="inherit" size={24} thickness={6} />
                ) : (
                  'Remove'
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(RemoveTeamMember);
